/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Pattern_Violated_DescInputs */



/**
* | output |
* | --- |
* | "User input violated the configured pattern rules" |
*
* @param {Audit_Details_Pattern_Violated_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_pattern_violated_desc = /** @type {((inputs?: Audit_Details_Pattern_Violated_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Pattern_Violated_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Benutzereingabe hat gegen die konfigurierten Musterregeln verstoßen")
	return /** @type {LocalizedString} */ ("User input violated the configured pattern rules")
});